<template>
  <div :class="['col-xs-12', `col-md-${size}`]">
    <label class="control-label" v-if="label">{{ label }}</label>
    <form-group-date-time-picker
      :value="value"
      :name="name"
      required="true"
      data-vv-as="Data Final do Atestado"
      format="DD/MM/YYYY"
      @input="$emit('input', $event)"
      v-validate="{ required: true }"
    />
  </div>
</template>

<script>
import DateTimePicker from "../../Forms/DateTimePicker";
export default {
  $_veeValidate: {
    validator: "new"
  },  
  components: {
    DateTimePicker
  },
  inject: ["$validator", "formValues"],
  name: "c-protocolo-data-final-atestado",
  props: {
    label: String,
    name: {
      required: true,
      type: String
    },
    size: {
      type: String,
      default: "6"
    },
    value: Date,
    required: Boolean
  },
  mounted() {
    this.$el.value = this.value;
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/Campos/DataFinalAtestado.vue